import {
  Autocomplete, Box, Dialog, IconButton, Skeleton, Table,
  TableBody, TableCell, TableHead, TableRow, TextField, Tooltip,
  Typography
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import {
  COMMON_STYLE, CV_OPTIONS, DEFAULT_CHARTUSED_SR, NV_TYPE_OPTIONS,
  PHVA_OPTION, UCVA_OPTIONS
} from '../../../../Utility/Constants';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';

const UmaVisionAssessment = React.forwardRef((props, ref) => {
  const [vission, setVission] = useState({
  patient_details: {},
  clinic_id: '',
  appointment_id: '',
  patient_id: '',
  chartUsedList: DEFAULT_CHARTUSED_SR,
  occupationList: [],
  UCVAList: UCVA_OPTIONS,
  PHList: PHVA_OPTION,
  PGCLList: PHVA_OPTION,
  NVList: NV_TYPE_OPTIONS,
  CVList: CV_OPTIONS,
  selectedChartUsed: '',
  selectedOccupation: '',
  vissionAssessmentData: [],
  vissionComments: '',
  loadScreen: false,
  prevVissionAssessmentData: [],
  prevVissionComments: '',
  prevSelectedChartUsed: '',
  prevSelectedOccupation: '',
  openComparePopup: false,
  enableCopy: false,
  enableCompare: false,
  dupVissionAssessmentData: '[]',
  dupVissionComments: '',
  dupSelectedChartUsed: '',
  dupSelectedOccupation: ''
})
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - VISION ASSESSMENT`,
    })
  }
const [inputValues, setInputValues] = useState({})
  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - VISION ASSESSMENT`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  // COMPONENT DID UPDATE
  useEffect(() => {
    if (vission.prevVissionAssessmentData && vission.vissionAssessmentData) {
      let copy = vission.prevVissionAssessmentData?.length > 0 ? vission.prevVissionAssessmentData?.some(item => (item?.UCVA !== '' || item?.PH !== '' || item?.PGCL !== '' || item?.NV !== '' || item?.DV !== '' || item?.CV !== '')) : false
      let view = vission.vissionAssessmentData?.length > 0 ? vission.vissionAssessmentData?.some(item => (item?.UCVA !== '' || item?.PH !== '' || item?.PGCL !== '' || item?.NV !== '' || item?.DV !== '' || item?.CV !== '')) : false
      setVission((prev) => ({
        ...prev,
        enableCopy: copy,
        enableCompare: view
      }))
    }
  }, [vission.prevVissionAssessmentData, vission.vissionAssessmentData])

  React.useImperativeHandle(ref, () => ({
    performVisionAssessmentAction: () => {
      if (
        (JSON.stringify(vission.vissionAssessmentData) !== vission.dupVissionAssessmentData) || (JSON.stringify(vission.selectedChartUsed) !== vission.dupSelectedChartUsed) ||
        (JSON.stringify(vission.selectedOccupation) !== vission.dupSelectedOccupation) || (JSON.stringify(vission.vissionComments) !== vission.dupVissionComments)
      ) {
        postVissionAssessmentData()
      }
    }
  }))

  const apicalls = async () => {
    await getvissionAssessmentOccupation()
    await getVissionAssessmentData()
    await getPreviousVissionAssessment()
  }

  const getVissionAssessmentData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_VISSION_ASSESSMENT + '?appointment_id=' + props.props?.appointment_id + '&doctor_id=' + props?.props?.doctorID)

      if (response?.data?.status === 'success') {
        let vissArray = [{ eye_type: "RE", UCVA: "", PH: "", PGCL: "", NV: "", DV: "", CV: "" },
        { eye_type: "LE", UCVA: "", PH: "", PGCL: "", NV: "", DV: "", CV: "" }]
        let vissionList = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : []
        setVission((prev) => ({
          ...prev,
          vissionAssessmentData: Object.keys(vissionList)?.length > 0 ? vissionList?.vision_data : vissArray,
          vissionComments: Object.keys(vissionList)?.length > 0 ? vissionList?.comments : '',
          selectedChartUsed: Object.keys(vissionList)?.length > 0 ? vissionList?.chart_used : null,
          selectedOccupation: Object.keys(vissionList)?.length > 0 ? vissionList?.occupation : null,

          dupVissionAssessmentData: Object.keys(vissionList)?.length > 0 ? JSON.stringify(vissionList?.vision_data) : JSON.stringify(vissArray),
          dupVissionComments: Object.keys(vissionList)?.length > 0 ? JSON.stringify(vissionList?.comments) : JSON.stringify(''),
          dupSelectedChartUsed: Object.keys(vissionList)?.length > 0 ? JSON.stringify(vissionList?.chart_used) : JSON.stringify(''),
          dupSelectedOccupation: Object.keys(vissionList)?.length > 0 ? JSON.stringify(vissionList?.occupation) : JSON.stringify(''),
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const getvissionAssessmentOccupation = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_OCCUPATION_LIST + '?doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        setVission((prev) => ({
          ...prev,
          occupationList: response?.data?.data
        }))
      }

    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const getPreviousVissionAssessment = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_VISSION_ASSESSMENT_COPY +
        '?appointment_id=' + props.props.appointment_id + '&patient_id=' + props.props.patient_id + '&doctor_id=' + props?.props?.doctorID
      )
      if (response?.data?.status === 'success') {
        let vissionList = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setVission((prev) => ({
          ...prev,
          prevVissionAssessmentData: Object.keys(vissionList)?.length > 0 ? vissionList?.vision_data : [],
          prevVissionComments: Object.keys(vissionList)?.length > 0 ? vissionList?.comments : '',
          prevSelectedChartUsed: Object.keys(vissionList)?.length > 0 ? vissionList?.chart_used : null,
          prevSelectedOccupation: Object.keys(vissionList)?.length > 0 ? vissionList?.occupation : null,
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const postVissionAssessmentData = async () => {
    try {
      let data = {
        appointment_id: props.props?.appointment_id,
        occupation: vission.selectedOccupation,
        comments: vission.vissionComments,
        chart_used: vission.selectedChartUsed,
        vision_data: vission.vissionAssessmentData
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_VISSION_ASSESSMENT)

      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getVissionAssessmentData()
        await getvissionAssessmentOccupation()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const autocompleteTextBox = (names, values, options = [], optionLabel, placeholders, index) => {
    try {
      const fieldKey = `${names}_${index}`;
      const handleStrictMatch = (inputValue) => {
          const matchedOption = options.find(
          (opt) => {
            const optionText =
              typeof opt === "string" ? opt : opt[optionLabel];

            return optionText?.toLowerCase() === inputValue?.toLowerCase();
          }
        );

        let vissionAssessmentData = [...vission.vissionAssessmentData];

        vissionAssessmentData[index] = {
          ...vissionAssessmentData[index],
          [names]: matchedOption ? matchedOption[optionLabel] : ""
        };

        setVission((prev) => ({ ...prev, vissionAssessmentData }));

        setInputValues((prev) => ({
          ...prev,
          [fieldKey]: matchedOption ? matchedOption[optionLabel] : ""
        }))
      }
      return (
        <Autocomplete
          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
          clearIcon
          size='small'
          sx={{ width: '6dvw' }}
          value={values || null}
          options={options}
          inputValue={inputValues[fieldKey] ?? values ?? ""}

          getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel] || ""}
          onChange={(e, newValue) => {
            let vissionAssessmentData = [...vission.vissionAssessmentData]
            vissionAssessmentData[index] = { ...vissionAssessmentData[index], [names]: newValue ? newValue[optionLabel] || "" : "" }
            setVission((prev) => ({ ...prev, vissionAssessmentData: vissionAssessmentData }))
            setInputValues((prev) => ({
              ...prev,
              [fieldKey]: newValue ? newValue[optionLabel] : ""
            }));
          }}

          onInputChange={(e, newInputValue) => {
            setInputValues((prev) => ({
              ...prev,
              [fieldKey]: newInputValue
            }));
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={placeholders}
              onBlur={(e) => handleStrictMatch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleStrictMatch(e.target.value);
                }
              }}
              InputProps={{
                ...params.InputProps, emed_tid: names,
                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
              }}
            />
          )}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderComparePopup = () => {
    try {
      return (
        <Dialog open={vission.openComparePopup} maxWidth="md" fullWidth>
          <Box className='doc_addendum_popup'>
            <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Typography className='doc_notes_header_card_font'>Compare Previous Glass Power</Typography>
              <IconButton emed_tid='cmp_prev_cls'
                onClick={() => setVission((prev) => ({ ...prev, openComparePopup: false }))}><CloseIcon /></IconButton>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Box component={'div'} display={'flex'} alignItems={'center'}>
                <Typography className='doc_notes_header_card_font'>Current Glass Power</Typography>
                <Tooltip placement='top' arrow title={'Copy'}>
                  <IconButton className='Common_Btn_Min_Width' sx={{ height: '3dvh' }} emed_tid='prev_cmp_cpy'
                    onClick={() => {
                      setVission((prev) => ({
                        ...prev,
                        vissionAssessmentData: vission.prevVissionAssessmentData,
                        vissionComments: vission.prevVissionComments,
                        selectedChartUsed: vission.prevSelectedChartUsed,
                        selectedOccupation: vission.prevSelectedOccupation,
                        openComparePopup: false
                      }))
                    }}
                  ><ContentCopyIcon color={'primary'} /></IconButton></Tooltip>
              </Box>
              <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                      <TableCell className='doc_notes_tbl_header'>UCVA</TableCell>
                      <TableCell className='doc_notes_tbl_header'>PH</TableCell>
                      <TableCell className='doc_notes_tbl_header'>PG/CL</TableCell>
                      <TableCell className='doc_notes_tbl_header'>NV</TableCell>
                      <TableCell className='doc_notes_tbl_header'>CV</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {vission.prevVissionAssessmentData?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.eye_type}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.UCVA}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.PH}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.PGCL}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.NV}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.CV}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Typography className='doc_notes_header_card_font'>New Glass Power</Typography>
              <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                      <TableCell className='doc_notes_tbl_header'>UCVA</TableCell>
                      <TableCell className='doc_notes_tbl_header'>PH</TableCell>
                      <TableCell className='doc_notes_tbl_header'>PG/CL</TableCell>
                      <TableCell className='doc_notes_tbl_header'>NV</TableCell>
                      <TableCell className='doc_notes_tbl_header'>CV</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {vission.vissionAssessmentData?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.eye_type}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.UCVA}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.PH}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.PGCL}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.NV}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell'>{item?.CV}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Box>
          </Box>
        </Dialog >
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderVissionTable = () => {
    try {
      return (
        <Box component={'div'} border={'1px solid lightgray'}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                <TableCell className='doc_notes_tbl_header'>UCVA</TableCell>
                <TableCell className='doc_notes_tbl_header'>PH</TableCell>
                <TableCell className='doc_notes_tbl_header'>PG/CL</TableCell>
                <TableCell className='doc_notes_tbl_header'>NV</TableCell>
                <TableCell className='doc_notes_tbl_header'>CV</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vission?.vissionAssessmentData?.length > 0 ? vission?.vissionAssessmentData?.map((item, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('UCVA', item?.UCVA, vission?.UCVAList, 'label', 'UCVA', index)}
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('PH', item?.PH, vission?.PHList, 'label', 'PH', index)}
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('PGCL', item?.PGCL, vission?.PGCLList, 'label', 'PGCL', index)}
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('NV', item?.NV, vission?.NVList, 'label', 'NV', index)}
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('CV', item?.CV, vission?.CVList, 'label', 'CV', index)}
                    </TableCell>
                  </TableRow>
                )
              }) : <TableRow><TableCell align='center' colSpan={6}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
            </TableBody>
          </Table>
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Box component={'div'}>
          <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <Typography className='doc_notes_header_card_font'>Vision Assessments</Typography>
            <Box component={'div'} display={'flex'} alignItems={'center'}>
              <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width'
                onClick={() => {
                  setVission((prev) => ({
                    ...prev,
                    vissionAssessmentData: vission.prevVissionAssessmentData,
                    vissionComments: vission.prevVissionComments,
                    selectedChartUsed: vission.prevSelectedChartUsed,
                    selectedOccupation: vission.prevSelectedOccupation
                  }))
                }}
                disabled={!vission.enableCopy || props?.props?.patient_transfered || props?.props?.isLocked}
              >{<ContentCopyIcon color={!vission.enableCopy ? '' : 'primary'} />}</IconButton></Tooltip>
              <Tooltip placement='top' arrow title={'View'}><IconButton className='Common_Btn_Min_Width'
                disabled={!(vission.enableCompare && vission.enableCopy) || props?.props?.patient_transfered || props?.props?.isLocked}
                onClick={() => setVission((prev) => ({ ...prev, openComparePopup: true }))}
              ><VisibilityIcon color={!(vission.enableCompare && vission.enableCopy) ? '' : 'primary'} /></IconButton></Tooltip>
            </Box>
          </Box>
          <Box component={'div'} m={'0.5rem'}>
            <Box component={'div'} display={'flex'}>
              <Autocomplete
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                clearIcon
                size='small'
                sx={{ width: '15dvw', mr: '1rem' }}
                value={vission.selectedChartUsed}
                options={vission.chartUsedList || null}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.label}
                onChange={(e, newValue) => {
                  setVission((prev) => ({ ...prev, selectedChartUsed: newValue?.label }))
                }}
                onInputChange={(e, inputValue) => {
                  setVission(prev => ({
                    ...prev,
                   selectedChartUsed: inputValue || ""
                  }));
                }}

                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder='Select Chart Used'
                    onBlur={(e) => {
                      const typedValue = e.target.value?.toLowerCase();
                      const match = vission.chartUsedList.find(
                        item => item.label.toLowerCase() === typedValue
                      );
                      setVission(prev => ({
                        ...prev,
                        selectedChartUsed: match ? match.label : ""
                      }));
                    }}

                    onKeyDown={(e) => {
                      if (e.key === "Enter") e.target.blur();
                    }}

                    InputProps={{
                      ...params.InputProps, emed_tid: 'vsn_cht',
                      style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                    }}
                  />
                )}
              />
              <Autocomplete
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                clearIcon
                size='small'
                // freeSolo
                sx={{ width: '15dvw' }}
                value={vission.selectedOccupation}
                options={vission.occupationList}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option}
                onChange={(e, newValue) => {
                  setVission((prev) => ({ ...prev, selectedOccupation: newValue }))
                }}
                onInputChange={(e, newValue) => {
                  setVission(prev => ({
                    ...prev,
                    selectedOccupation: newValue || ""
                  }))
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder='Select Occupation'
                    onBlur={(e) => {
                      const typedValue = e.target.value?.toLowerCase();

                      const match = vission.occupationList.find(
                        item => item.toLowerCase() === typedValue
                      );

                      setVission(prev => ({
                        ...prev,
                        selectedOccupation: match || ""
                      }));
                    }}

                    onKeyDown={(e) => {
                      if (e.key === "Enter") e.target.blur();
                    }}

                    InputProps={{
                      ...params.InputProps, emed_tid: 'vsn_occ',
                      style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                    }}
                  />
                )}
              />
            </Box>
            <Box component={'div'} m={'0.5rem 0rem'}>
              {renderVissionTable()}
            </Box>
            <Box component={'div'}>
              <TextField
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                size='small'
                multiline
                fullWidth
                maxRows={5}
                value={vission.vissionComments}
                onChange={(e) => {
                  let value = e.target.value
                  if (value?.length <= 1000) {
                    setVission((prev) => ({ ...prev, vissionComments: value }))
                  }
                }}
                placeholder='Comments'
                inputProps={{ emed_tid: 'vsn_cmts', maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
              />
            </Box>
          </Box>
        </Box>
        {renderComparePopup()}
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaVisionAssessment